import type React from 'react'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Snackbar from '@mui/material/Snackbar'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import NotificationsIcon from '@mui/icons-material/Notifications'
import CloseIcon from '@mui/icons-material/Close'
import styled from 'styled-components'
const GlassCard = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  min-width: 300px;
  max-width: 380px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
`

const IconWrap = styled(Box)`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

const TextWrap = styled(Box)`
  flex: 1;
  min-width: 0;
`

const NotifTitle = styled(Typography)`
  && {
    font-size: 13px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const NotifBody = styled(Typography)`
  && {
    font-size: 12px;
    color: rgba(30, 30, 30, 0.7);
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
    word-break: break-word;
  }
`

const CloseBtn = styled(IconButton)`
  && {
    padding: 2px;
    color: rgba(30, 30, 30, 0.45);
    flex-shrink: 0;
  }
`

const BellIcon = styled(NotificationsIcon)`
  && {
    font-size: 22px;
    color: #6366f1;
  }
`

const DismissIcon = styled(CloseIcon)`
  && {
    font-size: 14px;
  }
`

interface NotificationToastProps {
  open: boolean
  title: string
  body: string
  onClose: () => void
}

const NotificationToast = ({ open, title, body, onClose }: NotificationToastProps): React.JSX.Element => (
  <Snackbar
    open={open}
    autoHideDuration={5000}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
  >
    <GlassCard>
      <IconWrap>
        <BellIcon />
      </IconWrap>
      <TextWrap>
        <NotifTitle>{title}</NotifTitle>
        {body && (
          <Tooltip title={body.length > 60 ? body : ''} placement="bottom" arrow>
            <NotifBody>{body}</NotifBody>
          </Tooltip>
        )}
      </TextWrap>
      <CloseBtn size="small" onClick={onClose}>
        <DismissIcon />
      </CloseBtn>
    </GlassCard>
  </Snackbar>
)

export default NotificationToast
